// @ts-strict

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { validationExpressions } from '@app/core/helpers/constants';

interface IFieldsValues {
  description: string;
  website: string;
}

@Component({
  selector: 'app-promotion-method-description',
  templateUrl: './promotion-method-description.component.html',
  styleUrls: ['./promotion-method-description.component.scss']
})
export class PromotionMethodDescriptionComponent implements OnInit {
  @Input() isFormValidated?: EventEmitter<boolean>;
  @Input() isFormSubmitted: boolean = false;
  @Output() promotionData = new EventEmitter<{ description: string; website: string }>();

  public promotionMethodForm?: UntypedFormGroup;

  public fieldsValues: IFieldsValues = {
    description: '',
    website: ''
  };

  public activeElementsList = ['method_promotion', 'promotion_url'];
  public activeElement = this.activeElementsList[0];

  get formControls() {
    return this.promotionMethodForm?.controls;
  }

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.promotionMethodForm = this.fb.group({
      promotionMethodDescriptionInput: new UntypedFormControl('', Validators.required),
      promotionURLInput: new UntypedFormControl('', this.validateURL)
    });
  }

  public updateValue(type: string, input: string): void {
    if (this.formControls) {
      this.fieldsValues[type as keyof IFieldsValues] = this.formControls[input].value;
      this.promotionData.emit(this.fieldsValues);
    }
  }

  public validateURL(control: AbstractControl): null | { urlInvalid: boolean } {
    if (control.value && control.value.match(validationExpressions.url)) {
      return null;
    }
    return { urlInvalid: true };
  }
}
